import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  GET_CURRENT_USER,
  GET_CURRENT_USER_SUCCESS,
  GET_CURRENT_USER_FAIL,
  GET_SETTINGS,
  GET_SETTINGS_FAIL,
  GET_SETTINGS_SUCCESS,
  GET_CURRENT_USER_WALLET_ADDRESS,
  REQUEST_FOR_VERIFICATION,
  REQUEST_FOR_VERIFICATION_FAIL,
  REQUEST_FOR_VERIFICATION_SUCCESS,
  COLLECTION_REQ_FOR_VERIFICATION,
  COLLECTION_REQ_FOR_VERIFICATION_FAIL,
  COLLECTION_REQ_FOR_VERIFICATION_SUCCESS,
  FORGET_PASSWORD,
  FORGET_PASSWORD_FAILED,
  FORGET_PASSWORD_SUCCESSFUL,
  VERIFY_OTP,
  VERIFY_OTP_FAILED,
  VERIFY_OTP_SUCCESSFUL,
  PASSWORD_RESET,
  PASSWORD_RESET_FAILED,
  PASSWORD_RESET_SUCCESSFUL,
  VERIFY_EMAIL_AGAIN_SUCCESS,
  GET_PARTIULAR_USER,
  GET_PARTIULAR_USER_SUCCESSFUL,
  GET_PARTIULAR_USER_FAILED,
  POLYGON_SIGN_IN,
  POLYGON_SIGN_IN_FAILED,
  POLYGON_SIGN_IN_SUCCESSFUL,
} from "./actionTypes";

const { data, ...authUser } = JSON.parse(
  localStorage.getItem("authUser") || "{}"
);

const initialState = {
  meLoading: false,
  isAuthenticated: false,
  error: null,
  isMeFailed: false,
  error: "",
  loading: false,
  user: data || {},
  authToken: data ? data.Token || null : null,
  settings: null,
  currentWalletAddress: null,
  particularUserLoading: false,
  forgetError: null,
  resetError: null,
  verifyOtpError: null,
  particularUser: {},
  signInQr: {}
};

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
    case REQUEST_FOR_VERIFICATION:
    case COLLECTION_REQ_FOR_VERIFICATION:
      return {
        ...state,
        error: "",
        loading: true,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        error: "",
        user: action.payload.data,
        authToken: action.payload.data.Token,
        loading: false,
      };

    case LOGOUT_USER:
      return { ...state };
    case LOGOUT_USER_SUCCESS:
      return { ...state, user: action.payload, authToken: false };

    case API_ERROR:
      return { ...state, error: action.payload, loading: false };

    case GET_CURRENT_USER:
      return {
        ...state,
        error: "",
        meLoading: true,
        isMeFailed: false,
      };

    case GET_CURRENT_USER_SUCCESS:
      return {
        ...state,
        error: "",
        user: action.payload.data,
        meLoading: false,
        isMeFailed: false,
      };

    case GET_CURRENT_USER_FAIL:
    case REQUEST_FOR_VERIFICATION_FAIL:
    case REQUEST_FOR_VERIFICATION_SUCCESS:
    case COLLECTION_REQ_FOR_VERIFICATION_FAIL:
    case COLLECTION_REQ_FOR_VERIFICATION_SUCCESS:
      return {
        ...state,
        error: action.payload,
        loading: false,
        isMeFailed: true,
        meLoading: false,
      };

    case GET_SETTINGS:
      return {
        ...state,
        loading: true,
      };
    case GET_CURRENT_USER_WALLET_ADDRESS:
      return {
        ...state,
        currentWalletAddress: action.payload,
      };

    case GET_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        settings: action.payload,
      };

    case GET_SETTINGS_FAIL:
      return {
        ...state,
        loading: false,
      };

    case FORGET_PASSWORD:
      return {
        ...state,
        user: null,
        loading: true,
        forgetError: null,
      };

    case FORGET_PASSWORD_SUCCESSFUL:
      return {
        ...state,
        loading: false,
        user: action.payload,
        forgetError: null,
      };

    case FORGET_PASSWORD_FAILED:
      return {
        ...state,
        user: null,
        loading: false,
        forgetError: action.payload,
      };

    case PASSWORD_RESET:
      return {
        ...state,
        user: null,
        loading: true,
        resetError: null,
      };

    case PASSWORD_RESET_SUCCESSFUL:
      return {
        ...state,
        loading: false,
        user: action.payload,
        resetError: null,
      };

    case PASSWORD_RESET_FAILED:
      return {
        ...state,
        user: null,
        loading: false,
        resetError: action.payload,
      };

    case VERIFY_OTP:
      return {
        ...state,
        user: null,
        loading: true,
        verifyOtpError: null,
      };

    case VERIFY_OTP_SUCCESSFUL:
      return {
        ...state,
        loading: false,
        user: action.payload,
        verifyOtpError: null,
      };

    case VERIFY_OTP_FAILED:
      return {
        ...state,
        user: null,
        loading: false,
        verifyOtpError: action.payload,
      };
    case GET_PARTIULAR_USER:
      return {
        ...state,
        particularUserLoading: true,
      }
    case GET_PARTIULAR_USER_SUCCESSFUL:
      return {
        ...state,
        particularUserLoading: false,
        particularUser: action.payload,
      }
    case GET_PARTIULAR_USER_FAILED:
      return {
        ...state,
        particularUserLoading: false,
      }

    case 'AUTH_SUCCESS':
    case VERIFY_EMAIL_AGAIN_SUCCESS:
      return { ...state, isAuthenticated: true, error: null };

    case 'AUTH_FAILURE':
      return { ...state, isAuthenticated: false, error: action.payload };

    // polygon sign in
    case POLYGON_SIGN_IN:
      return {
        ...state,
        loading: true,
      }
    case POLYGON_SIGN_IN_SUCCESSFUL:
      return {
        ...state,
        loading: false,
        signInQr: action.payload,
      }
    case POLYGON_SIGN_IN_FAILED:
      return {
        ...state,
        loading: false,
      }
    // polygon auth update
    case POLYGON_SIGN_IN:
      return {
        ...state,
        loading: true,
      }
    case POLYGON_SIGN_IN_SUCCESSFUL:
      return {
        ...state,
        loading: false,
        signInQr: action.payload,
      }
    case POLYGON_SIGN_IN_FAILED:
      return {
        ...state,
        loading: false,
      }
    default:
      return { ...state };
  }
  return state;
};

export default login;